import { TriangleAlert } from 'lucide-react';

export function FallbackBackendUnavailable() {
  return (
    <div className="flex size-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 p-8 text-center">
      <TriangleAlert
        className="mb-4 size-10 text-gray-400"
        aria-hidden="true"
      />
      <h2 className="mb-2 text-lg font-semibold text-gray-700">
        No system logs available
      </h2>
      <div className="space-y-2 text-gray-500">
        <p>
          We couldn&apos;t load system logs at the moment. This may be a
          temporary issue.
        </p>
        <p>Please try again shortly.</p>
      </div>
    </div>
  );
}
